import 'babel-polyfill';

import 'delayed-scroll-restoration-polyfill';

import IsomorphicRelay from 'isomorphic-relay';

import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import app from 'depop/state';

import getEnvironment from './getEnvironment';

import renderEnvironment from './renderEnvironment';

import NProgress from 'nprogress';

import { identifyUser } from 'depop/utils/tracking';

import getCurrentUser from 'depop/getCurrentUser';

import { rehydrate } from 'glamor';
rehydrate(window._glam);


/*
 * We use native history state (not the history lib) for keeping track
 * of infinite scrolling for back button purposes. But we don't want it
 * to stick around for a refresh, so we clear it on initial load.
 */
window.history.replaceState({
  ...window.history.state,
  key: null,
  numResults: null,
}, null, null);

import { browserHistory } from 'react-router';

import {
  relay as relayData,
  store as storeData,
} from 'depop/config';

require.context('../client/assets', true, /.+/);

const store = createStore(app, storeData, applyMiddleware(
  thunk,
));

browserHistory.listenBefore(location => {
  const { action } = location;

  if (action === 'PUSH') {
    NProgress.start();
  }
});

const renderTarget = document.getElementById('mount');
const environment = getEnvironment();

IsomorphicRelay.injectPreparedData(environment, relayData);

renderEnvironment(renderTarget, store, environment, browserHistory);

getCurrentUser(environment).then(user => {
  if (user) {
    identifyUser({
      id: user.publicId,
      username: user.username,
    });
  }
});



// WEBPACK FOOTER //
// ../src/client/index.js